import React, { useEffect, useState } from 'react';
import { ClockIcon, UsersIcon } from 'lucide-react';
const TOTAL_CUPOS = 3000;
const REMAINING = 2849;
function pad(n: number) {
  return n.toString().padStart(2, '0');
}
export function CountdownUrgency() {
  /* Counts down from ~4h58m, resets each mount for demo urgency */
  const [seconds, setSeconds] = useState(4 * 3600 + 58 * 60 + 12);
  useEffect(() => {
    const id = setInterval(() => {
      setSeconds(s => s > 0 ? s - 1 : 0);
    }, 1000);
    return () => clearInterval(id);
  }, []);
  const h = Math.floor(seconds / 3600);
  const m = Math.floor(seconds % 3600 / 60);
  const s = seconds % 60;
  const pct = Math.round(REMAINING / TOTAL_CUPOS * 100);
  return <div className="rounded-xl border border-orange-500/40 bg-black/60 p-4 backdrop-blur-sm" data-id="element-101">
      <div className="flex items-center justify-center gap-2 text-orange-400" data-id="element-102">
        <ClockIcon className="h-4 w-4" data-id="element-103" />
        <span className="text-xs font-bold uppercase tracking-wider" data-id="element-104">
          This offer ends in
        </span>
      </div>

      <div className="mt-3 flex items-center justify-center gap-2" data-id="element-105">
        {[{
        v: pad(h),
        l: 'HRS'
      }, {
        v: pad(m),
        l: 'MIN'
      }, {
        v: pad(s),
        l: 'SEC'
      }].map((t, i) => <div key={i} className="flex items-center gap-2" data-id="element-106">
            <div className="flex flex-col items-center rounded-lg bg-neutral-800 px-3 py-2" data-id="element-107">
              <span className="font-display text-2xl leading-none text-white tabular-nums" data-id="element-108">
                {t.v}
              </span>
              <span className="mt-1 text-[9px] font-bold tracking-widest text-neutral-400" data-id="element-109">
                {t.l}
              </span>
            </div>
            {i < 2 && <span className="text-xl font-bold text-orange-400" data-id="element-110">:</span>}
          </div>)}
      </div>

      <div className="mt-4" data-id="element-111">
        <div className="mb-1.5 flex items-center justify-between text-xs" data-id="element-112">
          <span className="flex items-center gap-1.5 font-semibold text-neutral-300" data-id="element-113">
            <UsersIcon className="h-3.5 w-3.5 text-orange-400" data-id="element-114" />
            Spots remaining
          </span>
          <span className="font-bold text-orange-400" data-id="element-115">
            {REMAINING.toLocaleString('en-US')}
          </span>
        </div>
        <div className="h-3 w-full overflow-hidden rounded-full bg-neutral-800" data-id="element-116">
          <div className="h-full rounded-full bg-gradient-to-r from-orange-600 to-orange-400" style={{
          width: `${pct}%`
        }} data-id="element-117" />
        </div>
        <p className="mt-1.5 text-center text-[11px] text-neutral-400" data-id="element-118">
          Spots at this price go quickly!
        </p>
      </div>
    </div>;
}